import React from 'react';
import styles from './additionalDescription_separatorLine.scss';

function AdditionalDescriptionSeparatorLine() {
    return <hr data-testid='additional-description-separator-line'
      data-semantic-id='additional-description-separator-line' className={styles.horizontal_separator} />;
}

export default AdditionalDescriptionSeparatorLine;

